var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYuju(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2764",
    "data-name": "Rectangle 2764",
    width: 150,
    height: 142.501,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-yes_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "yes_2",
    "data-name": "yes \\u2013 2",
    clipPath: "url(#clip-yes_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6446",
    "data-name": "Group 6446",
    transform: "translate(0 3.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6445",
    "data-name": "Group 6445",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2395",
    "data-name": "Path 2395",
    d: "M75,0C33.579,0,0,31.9,0,71.251S33.579,142.5,75,142.5s75-31.9,75-71.249S116.421,0,75,0M68.569,32.777A11.465,11.465,0,1,1,57.1,44.242,11.465,11.465,0,0,1,68.569,32.777m68.46,54.349s-6.945,1.323-9.591-5.181a10.29,10.29,0,0,1-.511-4.512s1.687-15.147-11.468-17.5c0,0-21.9-4.557-30.28,14.479,0,0-2,5-1.029,34.541,0,0,.294,16.61-13.229,22.342,0,0-14.552,6.468-29.324-.956,0,0-10.754-4.492-13.6-9.848,0,0-1.837-3.674-.955-6.467,0,0,1.4-6.762,9.26-5.585a10.486,10.486,0,0,1,4.557,1.616,22.58,22.58,0,0,0,22.636.882s5.622-2.756,7.717-12.788c0,0,3.219-13.964-6.174-20.614,0,0-8.929-7.056-15.764-9.371,0,0-22.159-8.048-24.914-25.245,0,0-4.226-17.455,16.425-30.831,0,0,11.139-7.423,16.706.791,0,0,4.263,6.118-4.652,13.835,0,0-15.287,13.155-3.822,25.649,0,0,6.761,9.7,22.489,8.819,0,0,13.024-.882,29.25-15.14,0,0,12.994-11.392,30.633.148,0,0,11.685,7.936,13.574,26.6,0,0,1.544,12.678-7.938,14.332",
    transform: "translate(0 0)",
    fill: "#3d3f96"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYuju);
export default __webpack_public_path__ + "static/media/YUJU.57323db5c1b9ffd9cf15ff024be95d68.svg";
export { ForwardRef as ReactComponent };